export function formatText(text) {
    text = text.replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    text = text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
    return text
}